import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import { useEffect } from 'react';
import { setAuthToken } from './utils/set-token';
import { AppContextProvider, useAppContext } from './utils/context/app-context';
import Users from './components/main/users/Users';
import { UserInfo } from './types/user.types';
import MainLayout from './layouts/Main';
import Subscriptions from './components/main/Subscriptions';
import AiqPayments from './components/main/AiqPayments';
import CreatePlan from './components/main/plans/CreatePlan';
import useBrowserStorage from './hooks/use-browser-storage';
import Plans from './components/main/plans/Plans';
import UserChatData from './components/main/users/UserChatData';
import ChangePassword from './components/main/settings/ChangePassword';
import CreateAIModel from './components/main/ai-models/CreateAIModel';
import AiModels from './components/main/ai-models/AiModels';
import CreateOrganisation from './components/main/organisations/CreateOrganisation';
import Organisations from './components/main/organisations/Organisations';
import OrgUsers from './components/main/organisations/OrgUsers';
import Configurations from './components/main/configurations/Configurations';

function App() {
  const { getItem } = useBrowserStorage();
  const userInfo: UserInfo = JSON.parse(getItem('userInfo', 'local') || '{}');
  const { setUserInfo } = useAppContext();

  useEffect(() => {
    if (userInfo?.accessToken) {
      setAuthToken(userInfo.accessToken);
      setUserInfo(userInfo);
    }
  }, []);

  return (
    <div>
      <AppContextProvider>
        <div>
          <Router>
            <Routes>
              <Route path="" element={<MainLayout />} />
              <Route path="/" element={<MainLayout />}>
                <Route path='dashboard' element={<Dashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="users/:id" element={<UserChatData />} />
                <Route path="subscription-payments" element={<Subscriptions />} />
                <Route path="aiq-payments" element={<AiqPayments />} />
                <Route path="create-plan" element={<CreatePlan />} />
                <Route path="subscription-plans" element={<Plans />} />
                <Route path="subscription-plans/:id" element={<CreatePlan />} />
                <Route path="change-password" element={<ChangePassword />} />
                <Route path="ai-models" element={<AiModels />} />
                <Route path="ai-models/create" element={<CreateAIModel />} />
                <Route path="ai-models/update/:id" element={<CreateAIModel />} />
                <Route path="organisations" element={<Organisations />} />
                <Route path="organisations/create" element={<CreateOrganisation />} />
                <Route path="organisations/update/:id" element={<CreateOrganisation />} />
                <Route path="organisations/:orgId/users" element={<OrgUsers />} />
                <Route path="configurations" element={<Configurations />} />
              </Route>
              <Route path="/auth" element={<AuthLayout />}>
                <Route index element={<Login />} />
              </Route>
            </Routes>
          </Router>
        </div>
      </AppContextProvider>
    </div>
  );
}

export default App;
